<div
	class="edit-incident-container au-forms"
	[class.full-height]="!incident"
	[class.fullscreen]="isFullscreen$ | async"
>
	@if (incident) {
		<div class="edit-name">
			<au-cmms-entity-name
				[name]="incident.name"
				(inputBlur)="editIncident($event)"
				(controlReady)="addChildControl('name', $event)"
				namePreviewClasses="m-b-sxs"
			>
			</au-cmms-entity-name>
			<div
				class="icon-wrapper"
				matRipple
				matRippleColor="rgba(#1c4b31, 0.05)"
				[matRippleCentered]="true"
				[matMenuTriggerFor]="deleteBtnMenu"
			>
				<mat-icon class="secondary-text-icon"> more_vert </mat-icon>
			</div>
			<mat-menu #deleteBtnMenu="matMenu" xPosition="before" class="actions-menu">
				<button mat-menu-item (click)="openMessageComponent()">
					<mat-icon svgIcon="share"></mat-icon>
					<span class="button-share">{{ 'share' | translate }}</span>
				</button>
				<div class="divider"></div>
				<button mat-menu-item (click)="incidentDeleteBtnHandler()">
					<mat-icon class="critical-icon" svgIcon="delete"></mat-icon>
					<span class="button-delete">{{ 'delete' | translate }} </span>
				</button>
			</mat-menu>
		</div>
		<div id="General" class="row-container m-b-xs">
			<div class="created-by date-ago-row">
				<span class="label">{{ 'created' | translate }}</span>
				<au-avatar-with-name [data]="incident.createdBy"> </au-avatar-with-name>
				<span class="body-2 grey">{{ incident.created | dateAgo }}</span>
			</div>
			<cmms-entity-status
				[status]="incident.status"
				[statuses]="incidentStatuses"
				(updateStatus)="editIncident($event)"
			>
			</cmms-entity-status>
		</div>
		@if (!!incident.completedAt) {
			<div class="m-b-xs">
				<div class="horizontal-select closed-by date-ago-row">
					<p class="select-label">{{ 'closed' | translate }}</p>
					<span class="body-2 grey">{{ incident.completedAt | dateAgo }}</span>
				</div>
			</div>
		}
		<div class="location-and-open-in-dt">
			<cmms-locations-section
				[locationsInputList]="incident.locations"
				(locationsChanged)="locationsChanged($event)"
				(locationAncestry)="locationAncestry = $event"
			></cmms-locations-section>
			<open-dt-from-workspace
				[entityName]="'incident'"
				[entity]="incident"
			></open-dt-from-workspace>
		</div>
		<attach-new-quick-entity
			[parentEntityData]="incident"
			[shownActions]="[EntityType.REQUEST, EntityType.WORK_ORDER]"
			(createdEntity)="reloadPage()"
		/>
		<image-section
			(addExistingFileClicked)="navigateToExist($event)"
			[files]="attachedFiles"
		/>
		<div class="priority-and-category">
			<cmms-priority-level
				class="priority"
				[priorityLevel]="incident.priority"
				(priorityLevelChanged)="editIncident($event)"
			></cmms-priority-level>
			<cmms-entity-category
				class="category"
				[selectedCategory]="incident.category"
				(categoryChanged)="editIncident($event)"
			></cmms-entity-category>
		</div>
		<div class="assignee-section m-b-xs">
			<cmms-assignee-and-approver
				[approver]="incident.approvedBy"
				[assignee]="incident.assignee"
				(assigneeUpdate)="assigneeUpdate($event)"
				(approverUpdate)="approverUpdate($event)"
			></cmms-assignee-and-approver>
		</div>
		<div class="m-b-m">
			<cmms-date-picker
				(dateTimeChanged)="editIncident({ deadline: $event })"
				[date]="incident.deadline"
				[label]="'due_date' | translate"
				[placeholderText]="'choose_date' | translate"
				[restrictPastSelections]="true"
			/>
		</div>
		<div class="m-b-m">
			<cmms-date-picker
				(dateTimeChanged)="occurredAtChanged($event)"
				[date]="incident.occurredAt"
				[label]="'occurred_at' | translate"
				[placeholderText]="'choose_date' | translate"
			></cmms-date-picker>
		</div>
		<div class="m-b-m">
			<cmms-labels-section
				[labelsList]="incident.labels"
				(labelsListChanged)="editIncident($event)"
			/>
		</div>
		<div class="description m-b-m">
			<cmms-description
				[textModeEnabled]="true"
				[description]="incident.description"
				(descriptionBlur)="editIncident($event)"
			></cmms-description>
		</div>
		<div class="m-b-m">
			<maintenance-section [title]="'maintenance' | translate">
				<div class="maintenance-content">
					<div class="maintenance-row">
						<div class="l-control">
							<au-maintenance-selector
								[selectionType]="'DeviationTypeChoices'"
								[value]="incident.deviationType"
								(valueChanged)="updateWokOrderMaintenance({ deviationType: $event })"
							/>
						</div>
						<div class="m-control">
							<au-cmms-cost
								[labelName]="'cost_of_repair' | translate"
								[value]="incident?.costOfRepair?.toString()"
								(inputBlur)="updateWokOrderMaintenance({ costOfRepair: $event })"
							/>
						</div>
						<div class="s-control">
							<au-maintenance-selector
								[selectionType]="'CostAllocationChoices'"
								[value]="incident?.costAllocation"
								(valueChanged)="updateWokOrderMaintenance({ costAllocation: $event })"
							/>
						</div>
					</div>
					<div class="maintenance-row">
						<div class="l-control">
							<au-maintenance-selector
								[selectionType]="'TimeframeChoices'"
								[value]="incident.timeframe"
								(valueChanged)="updateWokOrderMaintenance({ timeframe: $event })"
							/>
						</div>
						<div class="m-control">
							<au-maintenance-selector
								[selectionType]="'ConsequenceRatingChoices'"
								[value]="incident.consequenceRating"
								(valueChanged)="updateWokOrderMaintenance({ consequenceRating: $event })"
							/>
						</div>
						<div class="s-control">
							<au-maintenance-selector
								[selectionType]="'RiskLevelChoices'"
								[value]="incident.riskLevel"
								(valueChanged)="updateWokOrderMaintenance({ riskLevel: $event })"
							/>
						</div>
					</div>
				</div>
			</maintenance-section>
		</div>
		<div id="Attachments" class="sections">
			<entity-section
				[entityType]="cmmsPages.editWorkOrder"
				(addNewEntityItem)="navigateTo($event)"
				(addExistingEntityItem)="navigateToExist($event)"
				[tableData]="attachedWO"
				[tableColumns]="tableConfig"
				(unlink)="unlinkWorkOrder($event.data)"
				(rowSelect)="viewSelected($event)"
			>
			</entity-section>
			<entity-section
				[entityType]="cmmsPages.editRequest"
				(addNewEntityItem)="navigateTo($event)"
				(addExistingEntityItem)="navigateToExist($event)"
				[tableData]="attachedRequest"
				[tableColumns]="tableConfig"
				(unlink)="unlinkRequest($event.data)"
				(rowSelect)="viewSelected($event)"
			>
			</entity-section>
			<assets-section
				(openAssets)="openAssets()"
				(newAsset)="navigateTo($event)"
				(rowSelect)="viewSelected($event.data)"
				(unlink)="unlinkAsset($event.data)"
				[assets]="attachedAssets"
			>
			</assets-section>
		</div>
		<div id="Files" class="sections">
			<au-file-loader
				[loadedFiles]="attachedFiles"
				[options]="{ fileTypesConfig }"
				[delegateDeleting]="true"
				[cardsView]="true"
				[askDeleting]="false"
				(controlReady)="addChildControl('files', $event)"
				(addExistingFileClicked)="navigateToExist($event)"
				(filesLoaded)="filesUpdates($event)"
				(filesDeleted)="filesDeleted($event)"
				(rowSelect)="viewSelected($event)"
			></au-file-loader>
		</div>
		<div id="Other" class="comments m-t-m">
			<au-comments
				[commentsList]="incident.comments"
				(deleteComment)="deleteCommentConfirmation($event)"
				(editComment)="editComment($event)"
			></au-comments>
		</div>
		<div class="type-comment">
			<comment-input (commentSubmitted)="submitComment($event)" />
		</div>
	} @else {
		<div class="spinner-wrapper">
			<mat-spinner diameter="60"></mat-spinner>
		</div>
	}
</div>
